export default __webpack_public_path__ + "static/media/kv_mettmann_dark.3d30c6f0.png";